jQuery(document).ready(function ($) {
  console.log('sticky');
  var topBar = $('.top-bar');
  var alertBar = $('.site-alert-bar--link');
  var offset = topBar.offset().top;
  var sticking = false;

  console.log(alertBar);

  $(window).on('scroll', function() {
    var scrolled = $(window).scrollTop();

    if (scrolled >= offset && !sticking) {
      topBar.css({ 'position': 'fixed'});
      $('body').css({'padding-top': topBar.height()});
    } else {
      topBar.css({ 'position': 'static'});
      $('body').css({ 'padding-top': 0 });
    }
  });
});